<template>
 
      <div class="flex flex-column pl-2 pr-2">
        <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
          <h2 class="">KATEGÓRIE</h2>
          <router-link to="/mod-stock/categories/0" >
            <PrimevueButton label="Pridať kategóriu" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
          </router-link>
        </div>
        <DataTable 
          scrollable :scrollHeight="`${this.vh - 290}px`"
          :value="this.categories"
          stripedRows
          row-hover
          v-model:selection="this.selectedCategory"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="editCategory(this.selectedCategory.id)"
          tableStyle="width: 100%"
          :virtualScrollerOptions="{ itemSize: 40 }"
        >

          <Column field="name" header="Názov" style="min-width: 10%">
            <template #body="slotProps">
              {{ slotProps.data.name }}
            </template>
          </Column>

          <Column field="description" header="Popis" style="min-width: 60%">

          </Column>

         
          <Column header="" >
            <template #body="slotProps">
              <PrimevueButton type="button" v-tooltip.top="{ value: 'Editácia kategórie' }" icon="pi pi-pencil" @click="editCategory(slotProps.data.id)" text size="small"/>
            </template>
          </Column>

          <Column header="" >
            <template #body="slotProps">
                <PrimevueButton type="button" icon="pi pi-trash" @click="deleteCategory(slotProps.data.id)" text severity="danger" size="small"/>
            </template>
          </Column>

        </DataTable>
      </div>

      <ConfirmDialog></ConfirmDialog>
</template>

<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import router from "@/router";
import notie from "notie/dist/notie";
import PrimevueButton from 'primevue/button';
import Column from "primevue/column";

export default {
  name: "CategoryList",
  components: {
    PrimevueButton,
    Column,
  },
  data() {
    return {
      store,
      categories: [],
      vh: 0,
      dialogClosedByAccept: false,
    }
  },
  beforeMount() {
    
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);

      fetch(this.store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //this.$emit('error', responseData.data);
              notie.alert({
                type: 'error',
                text: "Zoznam kategórií sa nepodarilo načítať"
              })
            } else {
              
              this.categories = responseData.data
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní kategórií" + error);
          })
    }
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    editCategory(id:number) {
      router.push('/mod-stock/categories/' + String(id))
    },
    
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

    deleteCategory(id:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ kategóriu?")){
        Security.requireToken();
        this.dialogClosedByAccept = false;
        this.$confirm.require({
          message: 'Naozaj chcete ODSTRÁNIŤ kategóriu?',
          header: 'Zmazanie kategórie',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            //this.user.admin = event.target.checked;
            this.dialogClosedByAccept = true;

            fetch(store.Api_url + "/v1/category/"+String(id)+"?query=deleted:0" , Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                //this.$emit('error', responseData.message);
                notie.alert({
                  type: 'error',
                  text: "Nepodarilo sa odstrániť kategóriu"
                })
              } else {

                this.categories = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Kategória bola odstránená",
                  position: "bottom"
                })
              }
            })
            .catch((error) => {
              //alert('chyba pri nacitani objednavok: ' + error)
              notie.alert({
                  type: 'error',
                  text: "Nastala chyba pri odstránení kategórie: "+error
                })             
            })
          },
          //reject: () => {
          //  this.user.admin = false;
          //},
          onHide: () => {
              //if(!this.dialogClosedByAccept){
              //  this.user.admin = false;
              //}
              this.dialogClosedByAccept = false;
          }

        });
        

 
      //}
    },
  }  
  
}
</script>



<style scoped>

</style>